<app-header *ngIf="isAuthenticated"></app-header>
<router-outlet></router-outlet>
<ng-http-loader [debounceDelay]="300" [extraDuration]="300"></ng-http-loader>
<notifier-container></notifier-container>